import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginForm, AuthenticationPageContainer } from '@/features/user/components'
import { z } from 'zod'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const fallback = '/' as const

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().optional().catch('')
  }),
  beforeLoad: async ({ context, search }) => {
    // Redirect if already authenticated
    if (context.auth.status !== 'ANONYMOUS') {
      throw redirect({ to: search.redirect || fallback })
    }

    return {
      auth: context.auth
    }
  },
  component: LoginComponent
})

function LoginComponent() {
  const { auth } = Route.useRouteContext()
  const { redirect } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { t } = useTranslation('_routes')

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<{ title: string; message?: string } | undefined>()

  useEffect(() => {
    console.log(auth.errorCode)
    if (auth.errorCode != null) {
      setError({
        title: t(`routes.login.errors.${auth.errorCode}.title`, {
          defaultValue: t(`routes.login.errors.UNKNOWN_ERROR.title`)
        }),
        message: t(`routes.login.errors.${auth.errorCode}.text`, {
          defaultValue: ''
        })
      })
    }
  }, [auth.errorCode, t])

  const handleSubmit = async (username?: string, password?: string) => {
    if (username === undefined || password === undefined) {
      setError({ title: 'Please fill in username and password' })
      return
    }

    try {
      setIsLoading(true)
      await auth.login(username, password)
      // Navigate to the redirect URL using router navigation
      navigate({ to: redirect || fallback })
    } catch {
      // TODO: Fix error handling
      setError({ title: 'Invalid username or password' })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthenticationPageContainer
      variant="login"
      advertisingChip={t('routes.login.main.advertising.chip')}
      advertisingTitle={t('routes.login.main.advertising.title')}
      advertisingSubtitle={t('routes.login.main.advertising.subTitle')}
    >
      <LoginForm error={error} isLoading={isLoading} onSubmit={handleSubmit} />
    </AuthenticationPageContainer>
  )
}
